import { useCachedQuery } from '@kaiizen/react-persistent-cache';
import { useKaiProApiClient } from '../useKaiProApiClient';

export const useCombinedProductSearch = (searchString: string) => {
  const kaiProApiClient = useKaiProApiClient();

  const query = useCachedQuery(
    `combinedProductSearch/${searchString}`,
    () => kaiProApiClient.searchCombinedProducts({ queryString: searchString }),
    { enabled: !!kaiProApiClient.token && !!searchString && searchString.length > 2, maxRetryMs: 0 },
  );

  return {
    results: query.data || [],
    isLoading: query.isLoading,
    searchAttempted: !!searchString && searchString.length > 2,
  };
};
